import React from "react";
import styles from "../styles/Header.module.css";
import ProgressIndicator from "./ProgressIndicator";
import QuestionTracker from "./QuestionTracker";
import { ProgressPhase } from "../types/interview";
import { useInterviewStore } from "../stores";
import { useUiCopy } from "../i18n/useUiCopy";

interface HeaderProps {
  jobTitle?: string;
  currentPhase: ProgressPhase;
}

const Header: React.FC<HeaderProps> = ({ jobTitle, currentPhase }) => {
  const copy = useUiCopy();
  const showJobDescription = useInterviewStore((state) => state.showJobDescription);
  const { currentQuestionIndex, totalQuestions } = useInterviewStore(
    (state) => state.interviewData
  );

  // Show question tracker when we have valid question data
  const shouldShowQuestionTracker =
    (currentPhase === "STANDARD" || (totalQuestions > 0 && currentQuestionIndex >= 0)) &&
    totalQuestions > 0;

  return (
    <header className={styles.header}>
      <div className={styles.headerContentWrapper}>
        <div className={styles.headerMainContent}>
          {/* Logo positioned on the left */}
          <div className={styles.logoContainer}>
            <img src="/theia-logo.png" alt={copy.logoAlt} className={styles.logo} />
          </div>

          {/* Centered content */}
          <div className={styles.centeredContent}>
            <div className={styles.headerText}>
              <h1 className={styles.title}>{copy.productTitle}</h1>
              {jobTitle && (
                <div className={styles.externalJobTitle}>
                  {jobTitle}
                  <button onClick={showJobDescription} className={styles.viewDescriptionButton}>
                    {copy.viewJobDescription}
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* Question Tracker on the right side */}
          {shouldShowQuestionTracker && (
            <div className={styles.questionTrackerContainer}>
              <QuestionTracker
                currentStep={currentQuestionIndex + 1}
                totalSteps={totalQuestions}
                interviewPhase={currentPhase}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.stepsBar}>
        <ProgressIndicator currentPhase={currentPhase} />
      </div>
    </header>
  );
};

export default Header;
